/**
 * Só impede o checkout se o carrinho tiver aliança SEM gravação.
 * Nos demais produtos (solitário, upgrade, joias, kits já gravados) o botão
 * Finalizar compra segue o fluxo nativo da Shopify (POST name=checkout),
 * para o pedido e as propriedades (tamanho, gravação, upgrade) irem no admin.
 */
(function () {
  const message =
    (window.AndradeGravacao && window.AndradeGravacao.checkoutMessage) ||
    'Toda aliança precisa da gravação do nome antes de finalizar.';

  function isCheckoutControl(el) {
    if (!el || !(el instanceof Element)) return false;
    if (el.matches('button[name="checkout"], input[name="checkout"]')) return true;
    return !!(el.closest && el.closest('button[name="checkout"], input[name="checkout"]'));
  }

  function checkoutShouldBlock() {
    return !!document.querySelector('form.cart-form[data-andrade-block-checkout="true"]');
  }

  function relatedForm(btn) {
    if (btn && btn.form) return btn.form;
    const attr = btn && btn.getAttribute && btn.getAttribute('form');
    if (attr) return document.getElementById(attr);
    return document.querySelector('form.cart-form');
  }

  function nativeCheckout(btn) {
    if (window.AndradeCheckout && typeof window.AndradeCheckout.go === 'function') {
      window.AndradeCheckout.go();
      return;
    }
    const form = relatedForm(btn);
    if (form && typeof form.requestSubmit === 'function') {
      form.requestSubmit(btn);
      return;
    }
    if (form) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '1';
      form.appendChild(input);
      form.submit();
      return;
    }
    window.location.assign('/checkout');
  }

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || !isCheckoutControl(target)) return;

      const btn = target.closest('button[name="checkout"], input[name="checkout"]');
      if (btn && btn.disabled) return;

      if (checkoutShouldBlock()) {
        event.preventDefault();
        event.stopPropagation();
        window.alert(message);
        return;
      }

      if (btn && !btn.form) {
        event.preventDefault();
        nativeCheckout(btn);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('cart-form')) return;
      if (form.getAttribute('data-andrade-block-checkout') !== 'true') return;

      const submitter = event.submitter;
      const isCheckout = !!(submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout');
      if (!isCheckout) return;

      event.preventDefault();
      window.alert(message);
    },
    true
  );
})();
